import { render, staticRenderFns } from "./PosterHome.vue?vue&type=template&id=0b1e3523"
import script from "./PosterHome.vue?vue&type=script&lang=js"
export * from "./PosterHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports